<div id="bot-details" [formGroup]="form">
  <table class="table-striped table-td-border-right table-no-border-bottom">
    <tr>
      <td colspan="3">
        <mat-label>Tenant ID</mat-label>
        <input id="tenant-id-input" class="destination-input-field" type="text" formControlName="tenantId"/>
      </td>
    </tr>
    <tr class="bot-message-container">
      <td colspan="2" id="bot-name">
        <mat-label>API Key</mat-label>
        <input class="destination-input-field" type="text" formControlName="apiKey" [placeholder]="isApiKeySet ? 'Value hidden' : ''"/>
      </td>
      <td colspan="2">
        <mat-label>Webhook Key</mat-label>
        <input class="destination-input-field" type="text" formControlName="webhookKey" [placeholder]="isWebHookKeySet ? 'Value hidden' : ''"/>
      </td>
    </tr>
  </table>
</div>
